import { parse } from "@babel/parser";
import traverse from "@babel/traverse";
import generate from "@babel/generator";
var Babel = require("@babel/standalone");

const header = `
  let ___count___ = 0
  const ___preventInfiniteLoop___ = () => {
    if (___count___ > 1000) {
      throw new Error('The number of iterations is limited to 1000')
    }
    ___count___ += 1
  }
`;

const OPTIONS = {
  presets: ["react", "env", "es2015", "es2017"],
};

export default function preprocess(str) {
  const ast = parse(str, { allowImportExportEverywhere: true });
  const detector = parse(`___preventInfiniteLoop___()`);

  traverse(ast, {
    ForStatement: function (path) {
      path.node.body.body.push(...detector.program.body);
    },
    WhileStatement: function (path) {
      path.node.body.body.push(...detector.program.body);
    },
    DoWhileStatement: function (path) {
      path.node.body.body.push(...detector.program.body);
    },
  });

  const modifiedCode = header + generate(ast).code;

  const { code } = Babel.transform(modifiedCode, OPTIONS);

  return code;
}
